import { IonLabel, IonTabBar, IonTabButton } from '@ionic/react';
import HomeIcon from '../../assets/icons/HomeIcon';
import MenuIcon from '../../assets/icons/MenuIcon';
import OrdersIcon from '../../assets/icons/OrdersIcon';
import { useTranslation } from 'react-i18next';
import useBasket from '../../../../hooks/basket/useBasket';
import useMobileRouter from '../../common/hooks/useMobileRouter';
import { Tabs } from '../../exports/Enums';
import { AnimatePresence, motion } from 'framer-motion';
import { useMemo } from 'react';

const Footer = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Components:Footers:Footer' });
  const { basketItemsCount } = useBasket();
  const { tab } = useMobileRouter();

  const BasketCountBadge = useMemo(() => {
    return (
      <AnimatePresence>
        {basketItemsCount > 0 && tab !== Tabs.Menu && (
          <motion.div
            key="basket-count-badge"
            className="absolute left-1/2 ml-[6px] border-[1px] border-white top-[2px] bg-brand-primary h-[18px] min-w-[18px] px-[4px] rounded-full flex items-center justify-center text-white text-xs"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.1, ease: 'linear' }}
          >
            <p className="text-center text-white text-[9px]">{basketItemsCount}</p>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }, [basketItemsCount, tab]);

  return (
    <IonTabBar
      slot="bottom"
      className="h-20 ion-color overflow-hidden bg-white rounded-t-3xl backdrop-blur-md shadow-[0_-4px_8px_rgba(0,0,0,0.12)]"
    >
      <IonTabButton tab="home" className="[&.tab-selected]:text-brand-primary group space-y-2 text-muted-foreground">
        <HomeIcon className="h-[26px] group-[.tab-selected]:stroke-brand-primary stroke-mobile-secondary" />
        <IonLabel className="text-xs">{t('tabs.home')}</IonLabel>
      </IonTabButton>
      <IonTabButton tab="menu" className="[&.tab-selected]:text-brand-primary group space-y-2 text-muted-foreground">
        <MenuIcon className="h-[26px] group-[.tab-selected]:stroke-brand-primary stroke-mobile-secondary relative" />
        <IonLabel className="text-xs">{t('tabs.menu')}</IonLabel>
        {BasketCountBadge}
      </IonTabButton>
      <IonTabButton tab="orders" className="[&.tab-selected]:text-brand-primary group space-y-2 text-muted-foreground">
        <OrdersIcon className="h-[26px] group-[.tab-selected]:stroke-brand-primary stroke-mobile-secondary" />
        <IonLabel className="text-xs">{t('tabs.orders')}</IonLabel>
      </IonTabButton>
    </IonTabBar>
  );
};

export default Footer;
